<script setup lang="ts">
defineProps<{ usp: string }>()

const isDesktop = useMediaQuery("(min-width: 1024px)")
</script>

<template>
  <li
    v-if="usp.length > 0"
    class="flex w-fit items-center gap-4 lg:flex-col xl:flex-row"
  >
    <UIcon
      name="check-filled"
      :size="isDesktop ? 'auto' : 'lg'"
      aria-hidden="true"
    />
    <span
      class="font-national2condensed text-marketing-mobile-p1-p1-regular-m text-[--theme-dark] lg:text-center lg:text-marketing-dekstop-p1-p1-regular-m xl:text-left"
    >{{ usp }}</span>
  </li>
</template>
